
import Vue from 'vue'
import JwtToken from '@/services/jwt-token'
import SessionStorage from '@/services/session-storage'

const state = {
  usuario: SessionStorage.get('usuario', []),
  usuarios: [],
  informacoes: [],
  usuarioEditar: [],
  usuarioTutor: [],
  meuVoluntario: [],
  ListaVoluntario: [],
  meuVoluntarioAtendimento: [],
  minhaBeneficiaria: [],
  ListaBeneficiaria: [],
  perfilAtual: '',
  permissoes: [],
  notificacoes: [],
  administradores: [],
  dadosDashboard: []
}

const getters = {
  getUsuario: state => {
    return state.usuario
  },
  // getUsuarioTutor: state => {
  //   return state.usuarioTutor
  // },
  getToken: state => {
    return state.usuario.token
  },
  validaPermissao: (state) => (permissao) => {
    if (state.permissoes.indexOf(permissao) > -1) {
      return true
    } else {
      return false
    }
  }
}

const mutations = {
  setUsuario (state, data) {
    state.usuario = data
  },
  setUsuarioTutor (state, data) {
    state.usuarioTutor = data
  },
  setAdministradores (state, data) {
    state.administradores = data
  },
  setUsuarios (state, data) {
    state.usuarios = data
  },
  setInformacoesDesistencia (state, data) {
    state.informacoes = data
  },
  setUsuarioEditar (state, data) {
    state.usuarioEditar = data
  },
  setMeuVoluntario (state, data) {
    state.meuVoluntario = data
  },
  setVoluntario (state, data) {
    state.ListaVoluntario = data
  },
  setMeuVoluntarioAtendimento (state, data) {
    state.meuVoluntarioAtendimento = data
  },
  setMinhaBeneficiaria (state, data) {
    state.minhaBeneficiaria = data
  },
  setBeneficiaria (state, data) {
    state.ListaBeneficiaria = data
  },
  setDadosDashboard (state, data) {
    state.dadosDashboard = data
  },
  setPerfilAtual (state, data) {
    state.perfilAtual = data
  },
  setNotificacoes (state, data) {
    state.notificacoes = data
  },
  atualizaPermissoes (state) {
    state.permissoes = SessionStorage.getObject('permissoes')
  }
}

const actions = {
  getUsuarios (context, config) {
    if (!config.page) {
      config.page = 1
    }

    if (!config.limit) {
      config.limit = 200
    }

    Vue.http.get('api/usuario?length=' + config.limit + '&page=' + config.page).then(response => {
      context.commit('setUsuarios', response.body.data.data)
    })
  },
  getUsuario (context, id) {
    Vue.http.get('api/usuario/' + id).then(response => {
      context.commit('setUsuarioEditar', response.data.data[0])
      context.commit('setNotificacoes', response.data.data[0].notificacoes)
      if (response.data.data[0].perfil_temporario) {
        context.commit('setPerfilAtual', response.data.data[0].perfil_temporario)
      } else {
        context.commit('setPerfilAtual', response.data.data[0].perfil_id)
      }
    })
  },
  getUsuario3 (context, id) {
    Vue.http.get('api/usuariotoken/' + id).then(response => {
      context.commit('setUsuarioEditar', response.data.data[0])
      context.commit('setNotificacoes', response.data.data[0].notificacoes)
      if (response.data.data[0].perfil_temporario) {
        context.commit('setPerfilAtual', response.data.data[0].perfil_temporario)
      } else {
        context.commit('setPerfilAtual', response.data.data[0].perfil_id)
      }
    })
  },
  getUsuarioTutor (context, id) {
    Vue.http.get('api/usuario/' + id).then(response => {
      context.commit('setUsuarioTutor', response.data.data[0])
    })
  },
  informacoesDesistencia (context, id) {
    Vue.http.post('api/usuario/usuario-informacoes-desistencia', {usuario_id: parseInt(id)}).then(response => {
      context.commit('setInformacoesDesistencia', response.data.data.informacoes)
    })
  },
  getMeuVoluntario (context, id) {
    Vue.http.get('api/beneficiarios/meuVoluntario/' + id).then(response => {
      context.commit('setMeuVoluntario', response.data.data[0])
    })
  },
  getMeuVoluntarioAtendimento (context, data) {
    Vue.http.post('api/beneficiarios/meuVoluntarioAtendimento', data).then(response => {
      context.commit('setMeuVoluntarioAtendimento', response.data.data[0])
    })
  },
  getVoluntario (context, data) {
    Vue.http.get('api/beneficiarios/listaVoluntarios').then(response => {
      context.commit('setVoluntario', response.data.data[0])
    })
  },
  getVoluntario2 (context, id) {
    Vue.http.get('api/beneficiarios/listaVoluntarios-uf/'+id).then(response => {
      context.commit('setVoluntario', response.data.data[0])
    })
  },
  getVoluntario3 (context, id) {
    Vue.http.get('api/beneficiarios/listaVoluntarios-municipio/'+ id).then(response => {
      context.commit('setVoluntario', response.data.data[0])
    })
  },
  getVoluntario4 (context, config) {
    Vue.http.get('api/beneficiarios/listaVoluntarios-encontro', config).then(response => {
      context.commit('setVoluntario', response.data.data[0])
    })
  },
  getBeneficiaria (context, id) {
    Vue.http.get('api/beneficiarios/listaBeneficiarios').then(response => {
      context.commit('setBeneficiaria', response.data.data[0])
    })
  },
  getBeneficiaria2 (context, id) {
    Vue.http.get('api/beneficiarios/listaBeneficiarios-uf/'+id).then(response => {
      context.commit('setBeneficiaria', response.data.data[0])
    })
  },
  getBeneficiaria3 (context, id) {
    Vue.http.get('api/beneficiarios/listaBeneficiarios-municipio/'+id).then(response => {
      context.commit('setBeneficiaria', response.data.data[0])
    })
  },
  getBeneficiaria4 (context, config) {
    Vue.http.get('api/beneficiarios/listaBeneficiarios-encontro', config).then(response => {
      context.commit('setBeneficiaria', response.data.data[0])
    })
  },
  getAdministradores (context) {
    Vue.http.get('api/usuarios-administradores').then(response => {
      context.commit('setAdministradores', response.data.data.administradores)
    })
  },
  getMinhaBeneficiaria (context, id) {
    Vue.http.get('api/beneficiarios/minhaBeneficiaria/' + id).then(response => {
      context.commit('setMinhaBeneficiaria', response.data.data[0])
    })
  },
  getDadosDashboard (context) {
    Vue.http.get('api/usuario/dashboard').then(response => {
      context.commit('setDadosDashboard', response.body.data)
    })
  },
  login (context, data) {
    return JwtToken.accessToken(data)
  },
  atualizarPermissoes (context) {
    context.commit('atualizaPermissoes')
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/usuario.js